import axiosInstance from 'api/axiosInstance';

export const dismissOverstay = async (
	ticketNumber: string,
	dismissedByUserId: number,
): Promise<void> => {
	await axiosInstance.post(
		`/api2.0/overstays/dismiss`,
		{ ticketNumber, dismissedByUserId },
		{ headers: { 'Content-Type': 'application/json' } },
	);
};
